import React from "react";
import Flex from "../../components/templates/flex";
import { Icon } from "../../components/icon";
import { TextBig } from "../../components/typography";
import { Button } from "../../components/button";
var Header = function (_a) {
    var onClose = _a.onClose;
    return (React.createElement(Flex, { border: { side: "bottom", color: "selected" }, justifyContent: "between", alignItems: "center", padding: [0, 0, 4, 0] },
        React.createElement(Flex, { gap: 2 },
            React.createElement(Icon, { color: "text", name: "insights" }),
            React.createElement(TextBig, { strong: true }, "Netdata News")),
        React.createElement(Button, { flavour: "borderless", neutral: true, icon: "x", title: "close news", onClick: onClose })));
};
export default Header;
